import { render, staticRenderFns } from "./TextEditor2.vue?vue&type=template&id=a7b56902"
import script from "./TextEditor2.vue?vue&type=script&lang=js"
export * from "./TextEditor2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports